<template>
  <div class="flex flex-col">
    <label
      v-for="option in options"
      :key="option.value"
      :class="`bg-${themeColor}-100`"
    >
      <input
        :id="option.value"
        v-model="selectedValue"
        type="radio"
        :value="option.value"
        :class="`text-${themeColor}-600 focus:ring-${themeColor}-500 bg-${themeColor}`"
        class="ml-1 mr-3 border-gray-300"
        @change="$emit('update:modelValue', selectedValue)"
      />
      {{ option.label }}
    </label>
  </div>
</template>

<script setup lang="ts">
  import { computed, watch } from 'vue'
  import { useFormField } from '@/composables/useFormField'
  import { useThemeColor } from '@/composables/useThemeColor'
  import { useTranslation } from '@/composables/useTranslation'

  const emit = defineEmits(['update:modelValue'])

  const props = defineProps({
    field: {
      type: Object,
      required: true
    },
    modelValue: {
      type: [String, Boolean],
      default: null
    }
  })

  const { selectedValue } = useFormField(props)
  const themeColor = computed(() => useThemeColor().value)

  const { t } = useTranslation({
    en: {
      noAnswer: 'No answer'
    },
    de: {
      noAnswer: 'keine Angabe'
    }
  })

  const options = computed(() => {
    if (props.field.type === 'yesno') {
      return [
        { value: true, label: 'Ja' },
        { value: false, label: 'Nein' }
      ]
    }
    return props.field.choices.map((choice: any) => ({
      value: choice,
      label: choice === '' ? t('noAnswer') : choice
    }))
  })

  // Ensure the correct option is selected when the component mounts or modelValue changes
  watch(
    () => props.modelValue,
    (newValue) => {
      selectedValue.value = newValue
    },
    { immediate: true }
  )
</script>

<style scoped>
  label {
    display: flex;
    align-items: center;
    padding: 5px 1rem 5px 5px;
    border-radius: 3px;
    margin: 5px 0;
    cursor: pointer;
  }
</style>
